import messages from "./secret-questions-messages";

export default {
  cob: messages.cityOfBirth,
  fan: messages.favoriteAnimal,
  fbk: messages.favoriteBook,
  fcl: messages.favoriteColor,
  fpn: messages.favoritePetName,
  l4c: messages.lastDigitsCreditCard
};
